import React from 'react';
import styles from './CLToast.module.scss';
import {ToastMessage} from '../../modules/toasts/toasts.types';

function CLToast({title, message}: ToastMessage) {
  return (
    <div className={styles.cl_common_toast}>
      {title && <div className={styles.toast_title}>{title}</div>}
      <div>{message}</div>
    </div>
  );
}

export default CLToast;
